/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface MessagesService {
  /**
   * @summary Send Message
   * @description Send a message in a conversation.
   */
  sendMessageMessagingConversationIdMessagesPost: {
    /**
     * @summary Send Message
     * @description Send a message in a conversation.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SendMessageMessagingConversationIdMessagesPostBody,
        SendMessageMessagingConversationIdMessagesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SendMessageMessagingConversationIdMessagesPostSchema,
        options: ServiceOperationMutationFnOptions<
          SendMessageMessagingConversationIdMessagesPostBody,
          SendMessageMessagingConversationIdMessagesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          SendMessageMessagingConversationIdMessagesPostData,
          SendMessageMessagingConversationIdMessagesPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        SendMessageMessagingConversationIdMessagesPostData,
        SendMessageMessagingConversationIdMessagesPostError
      >
    >;
    /**
     * @summary Send Message
     * @description Send a message in a conversation.
     */
    getMutationKey(
      parameters: DeepReadonly<SendMessageMessagingConversationIdMessagesPostParameters> | void
    ): ServiceOperationMutationKey<
      SendMessageMessagingConversationIdMessagesPostSchema,
      SendMessageMessagingConversationIdMessagesPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Send Message
     * @description Send a message in a conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagesService.sendMessageMessagingConversationIdMessagesPost.useMutation({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagesService.sendMessageMessagingConversationIdMessagesPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         conversation_id: conversationId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SendMessageMessagingConversationIdMessagesPostBody, TContext = unknown>(
      parameters: DeepReadonly<SendMessageMessagingConversationIdMessagesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        SendMessageMessagingConversationIdMessagesPostSchema,
        SendMessageMessagingConversationIdMessagesPostData,
        SendMessageMessagingConversationIdMessagesPostParameters,
        TVariables,
        OperationError<SendMessageMessagingConversationIdMessagesPostError>,
        TContext
      >
    ): UseMutationResult<
      SendMessageMessagingConversationIdMessagesPostData,
      OperationError<SendMessageMessagingConversationIdMessagesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Send Message
     * @description Send a message in a conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagesService.sendMessageMessagingConversationIdMessagesPost.useMutation({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagesService.sendMessageMessagingConversationIdMessagesPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         conversation_id: conversationId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        SendMessageMessagingConversationIdMessagesPostBody,
        SendMessageMessagingConversationIdMessagesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SendMessageMessagingConversationIdMessagesPostSchema,
        SendMessageMessagingConversationIdMessagesPostData,
        SendMessageMessagingConversationIdMessagesPostParameters,
        TVariables,
        OperationError<SendMessageMessagingConversationIdMessagesPostError>,
        TContext
      >
    ): UseMutationResult<
      SendMessageMessagingConversationIdMessagesPostData,
      OperationError<SendMessageMessagingConversationIdMessagesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Send Message
     * @description Send a message in a conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const sendMessageMessagingConversationIdMessagesPostTotal = qraft.messagesService.sendMessageMessagingConversationIdMessagesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const sendMessageMessagingConversationIdMessagesPostTotal = qraft.messagesService.sendMessageMessagingConversationIdMessagesPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             conversation_id: conversationId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SendMessageMessagingConversationIdMessagesPostSchema,
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Send Message
     * @description Send a message in a conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const sendMessageMessagingConversationIdMessagesPostPendingMutationVariables = qraft.messagesService.sendMessageMessagingConversationIdMessagesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const sendMessageMessagingConversationIdMessagesPostMutationData = qraft.messagesService.sendMessageMessagingConversationIdMessagesPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 conversation_id: conversationId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SendMessageMessagingConversationIdMessagesPostData,
        OperationError<SendMessageMessagingConversationIdMessagesPostError>,
        MutationVariables<
          SendMessageMessagingConversationIdMessagesPostBody,
          SendMessageMessagingConversationIdMessagesPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SendMessageMessagingConversationIdMessagesPostSchema,
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SendMessageMessagingConversationIdMessagesPostData,
          OperationError<SendMessageMessagingConversationIdMessagesPostError>,
          MutationVariables<
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Send Message
     * @description Send a message in a conversation.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SendMessageMessagingConversationIdMessagesPostSchema,
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Send Message
     * @description Send a message in a conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.messagesService.sendMessageMessagingConversationIdMessagesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             conversation_id: conversationId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.messagesService.sendMessageMessagingConversationIdMessagesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SendMessageMessagingConversationIdMessagesPostBody,
              SendMessageMessagingConversationIdMessagesPostData,
              SendMessageMessagingConversationIdMessagesPostParameters,
              OperationError<SendMessageMessagingConversationIdMessagesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SendMessageMessagingConversationIdMessagesPostSchema,
              SendMessageMessagingConversationIdMessagesPostBody,
              SendMessageMessagingConversationIdMessagesPostData,
              SendMessageMessagingConversationIdMessagesPostParameters,
              OperationError<SendMessageMessagingConversationIdMessagesPostError>,
              TContext
            >
      ):
        | Mutation<
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostError,
            MutationVariables<
              SendMessageMessagingConversationIdMessagesPostBody,
              SendMessageMessagingConversationIdMessagesPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SendMessageMessagingConversationIdMessagesPostBody,
              SendMessageMessagingConversationIdMessagesPostData,
              SendMessageMessagingConversationIdMessagesPostParameters,
              OperationError<SendMessageMessagingConversationIdMessagesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SendMessageMessagingConversationIdMessagesPostSchema,
              SendMessageMessagingConversationIdMessagesPostBody,
              SendMessageMessagingConversationIdMessagesPostData,
              SendMessageMessagingConversationIdMessagesPostParameters,
              OperationError<SendMessageMessagingConversationIdMessagesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          SendMessageMessagingConversationIdMessagesPostData,
          SendMessageMessagingConversationIdMessagesPostError,
          MutationVariables<
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostParameters
          >,
          TContext
        >
      >;
    };
    schema: SendMessageMessagingConversationIdMessagesPostSchema;
    types: {
      parameters: SendMessageMessagingConversationIdMessagesPostParameters;
      data: SendMessageMessagingConversationIdMessagesPostData;
      error: SendMessageMessagingConversationIdMessagesPostError;
      body: SendMessageMessagingConversationIdMessagesPostBody;
    };
  };
}
/**
 * @summary Send Message
 * @description Send a message in a conversation.
 */
export const sendMessageMessagingConversationIdMessagesPost = {
  schema: {
    method: 'post',
    url: '/messaging/{conversation_id}/messages',
    mediaType: ['application/json'],
  },
} as {
  schema: SendMessageMessagingConversationIdMessagesPostSchema;
  [QraftServiceOperationsToken]: MessagesService['sendMessageMessagingConversationIdMessagesPost'];
};
export const messagesService = {
  sendMessageMessagingConversationIdMessagesPost,
} as const;
type SendMessageMessagingConversationIdMessagesPostSchema = {
  method: 'post';
  url: '/messaging/{conversation_id}/messages';
  mediaType: ['application/json'];
};
type SendMessageMessagingConversationIdMessagesPostParameters =
  paths['/messaging/{conversation_id}/messages']['post']['parameters'];
type SendMessageMessagingConversationIdMessagesPostData =
  paths['/messaging/{conversation_id}/messages']['post']['responses']['200']['content']['application/json'];
type SendMessageMessagingConversationIdMessagesPostError =
  paths['/messaging/{conversation_id}/messages']['post']['responses']['422']['content']['application/json'];
type SendMessageMessagingConversationIdMessagesPostBody =
  paths['/messaging/{conversation_id}/messages']['post']['requestBody']['content']['application/json'];
